import { PropsWithChildren, useRef } from 'react'
import { useCheckboxGroupContext } from 'components/CheckboxGroup/CheckboxGroupContext'
import { useCheckboxGroupItem } from '@react-aria/checkbox'
import { VisuallyHidden } from '@react-aria/visually-hidden'
import Styles from './Checkbox.module.scss'
import { CheckboxChecked } from 'blaze-ui/icons'
import CheckboxLight from 'blaze-ui/icons/20/CheckboxLight'
import { CheckboxProps } from 'components/CheckboxGroup/Types'
import cx from 'classnames'

export const Checkbox = ({ size, color, className, ...props }: PropsWithChildren<CheckboxProps>) => {
  const state = useCheckboxGroupContext()
  const ref = useRef(null)
  const { inputProps } = useCheckboxGroupItem(props, state, ref)

  const isSelected = state.isSelected(props.value)

  return (
    <label className={cx(Styles.label, className)}>
      <VisuallyHidden>
        <input {...inputProps} ref={ref} />
      </VisuallyHidden>
      <div className={cx(Styles.checkbox, { [Styles.selected]: isSelected })}>
        {isSelected ? <CheckboxChecked size={size} color={color} /> : <CheckboxLight size={size} color={color} />}
      </div>
      {props.children}
    </label>
  )
}
